import {lazy} from "react";

const DocumentEditor = lazy(() => import("./DocumentEditor"));

const documentRoutes = [
    {
        path: "/document/:id",
        element: <DocumentEditor/>,
    },
];

export default documentRoutes;